// extracted by mini-css-extract-plugin
export default {"faqHeader":"Faq_faqHeader__HwoUx"};